/**
 * Copyright 2020 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const deleteEvent = `mutation DeleteEvent($customer_id: String!, $event_id: String!) {
    deleteEvent(customer_id: $customer_id, event_id: $event_id)
  }
  `;
